// Imports
import Swiper from 'swiper/swiper-bundle.mjs';

// Inits
window.swiper = window.Swiper = Swiper;